<template>
  <div
      :class="className === undefined ? 'patient_info_value grid-item c_selector' : className">
    <v-select
        :key="item.index"
        v-model="item.values"
        :options="item.keyRange"
        :get-option-label="option => option.trans ? this.$t(option.trans) : option.title"
        :selectable="(option) => !option.disabled"
        append-to-body
        :calculate-position="withPopper"
    >
      <template #search="{ attributes, events }">
        <input
            class="vs__search"
            v-bind="attributes"
            v-on="events"
        />
      </template>
      <template
          v-slot:option="option"
      >
        <span
            v-if="item.keyRange.length > 1"
            v-tooltip="option.trans ? $t(option.trans) : option.title"
        >
          {{ option.trans ? $t(option.trans) : option.title }}
        </span>
        <span
            v-else
        >
          {{ option.trans ? $t(option.trans) : option.title }}
        </span>
      </template>
      <span slot="no-options">{{ $t('patients.no_search_data') }}</span>
    </v-select>
  </div>
</template>
<script>
import { createPopper } from '@popperjs/core'

export default {
  name: 'selectBox',
  props: [
    'item',
    'className'
  ],
  methods: {
    withPopper(dropdownList, component, {width}) {
      dropdownList.style.width = width
      const popper = createPopper(component.$refs.toggle, dropdownList, {})

      return () => popper.destroy()
    },
  },
}
</script>
<style lang="scss">
.vs__dropdown-menu {
  .vs__dropdown-option--disabled {
    background-color: #d2d0ce !important;
  }
}

.c_selector {
  .vs__dropdown-toggle:focus-within {
    border: 1px solid var(--blue70);
  }

  .vs__dropdown-toggle:disabled {
    background-color: var(--grey10) !important;
  }
}
</style>
